<script>
    export let currentIndex = 0;
    export let totalFiles = 0;
</script>

<div class="upload-overlay">
    <div class="uploader">
        <div class="text-center">
            Uploading file {currentIndex} of {totalFiles} ...
        </div>
    </div>
</div>

<style>
    .upload-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.2);
        z-index: 9000;
    }

    .uploader {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 1.2rem;
        background: #fff;
        box-shadow: 0 0 14px -2px rgba(0, 0, 0, 0.70);
        padding: 30px;
    }
</style>